import { render, staticRenderFns } from "./ControlSpinbutton.vue?vue&type=template&id=23a7b115"
import script from "./ControlSpinbutton.vue?vue&type=script&lang=js"
export * from "./ControlSpinbutton.vue?vue&type=script&lang=js"
import style0 from "./ControlSpinbutton.vue?vue&type=style&index=0&id=23a7b115&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports